import React from 'react';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    quote: 'Their Virtual CFO support gave us complete financial clarity and helped us scale confidently. Truly a game-changer for our business.',
    name: '[Name withheld under NDA]',
    title: 'Founder, Technology Startup — Mumbai',
    initial: 'F',
    gradient: 'from-emerald-400 to-teal-500',
  },
  {
    quote: 'We finally have MIS reports we can actually understand and act on. Cash flow has never been better managed.',
    name: '[Name withheld under NDA]',
    title: 'Director, Manufacturing SME — Rajasthan',
    initial: 'D',
    gradient: 'from-blue-400 to-indigo-500',
  },
  {
    quote: 'Responsive, deeply knowledgeable and genuinely invested in our growth. We consider them a core part of our team.',
    name: '[Name withheld under NDA]',
    title: 'MD, Family Business — Gujarat',
    initial: 'M',
    gradient: 'from-amber-400 to-orange-500',
  },
];

export const TestimonialsSection = () => (
  <section id="testimonials" className="py-16 sm:py-20 px-4 sm:px-6 bg-gray-50">
    <div className="max-w-7xl mx-auto">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-3">What Our Clients Say</h2>
      <p className="text-gray-600 text-center mb-10 sm:mb-12 max-w-2xl mx-auto">Trusted by businesses across India for financial clarity and strategic growth.</p>
      <div className="grid md:grid-cols-3 gap-6">
        {testimonials.map((t, i) => (
          <div key={t.quote?.slice(0,20) || `testimonial-${i}`} className="bg-white rounded-xl p-6 sm:p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow relative">
            <Quote className="w-8 h-8 text-emerald-200 mb-4" />
            <p className="text-gray-700 leading-relaxed mb-6 italic">"{t.quote}"</p>
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 bg-gradient-to-br ${t.gradient} rounded-full flex items-center justify-center text-white font-bold text-sm`}>
                {t.initial}
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-500">{t.name}</p>
                <p className="text-xs text-gray-500">{t.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-400 text-center mt-6 italic">* Client identities are protected under confidentiality agreements. Testimonials are real and shared with permission.</p>
    </div>
  </section>
);
